import { render, staticRenderFns } from "./investorsListView.vue?vue&type=template&id=dda70f1e&scoped=true"
import script from "./investorsListView.vue?vue&type=script&lang=js"
export * from "./investorsListView.vue?vue&type=script&lang=js"
import style0 from "./investorsListView.vue?vue&type=style&index=0&id=dda70f1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dda70f1e",
  null
  
)

export default component.exports